import {
  CloudDownloadOutlined
} from '@ant-design/icons'
import { Typography } from 'antd'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { useContext } from 'react'
import SortIcon from '../components/SortIcon'
import { TableProps } from '../types'

type WithDownloadOptionProps<T, K> = TableProps<T, K> & {
  configMap: Array<string>
}

export default function WithDownloadOption<T, K>({ header, items, configMap, onSortCallback, sort, onSingleDownload}: WithDownloadOptionProps<T, K>) {
  const t = useContext(I18nContext)

  return (
    <div className="simple-table-with-checkbox">
      <div className="simple-table-header">
        <div className="columns">
          {header.map((config) => <div className='column' key={config.key}>
            {t(config.label)}
            {onSortCallback ? SortIcon({ field: config, sort, onSortCallback }) : ''}
          </div>)}
        </div>
      </div>
      <div>
        <div className="simple-table-body">
          {items.map((item: any, rowIndex) => <div
            className={`columns ${rowIndex % 2 !== 0 && 'stripped'} simple-table-with-checkbox-row-with-download`}
            key={rowIndex}>
            {configMap.map((key, index) => <div className='column' key={index}>
              <Typography.Text>{item[key]}</Typography.Text>
            </div>)}
            <CloudDownloadOutlined className="row-download-icon" onClick={() => onSingleDownload(rowIndex)
            }/>
          </div>)}
        </div>
      </div>
    </div>
  )
}